import React from 'react';
import LegalDocumentLayout from '../../components/legal/LegalDocumentLayout';
import { getLegalPage } from '../../content/legal/legalPages';

function PrivacyPolicyPage() {
  const page = getLegalPage('privacy-policy');
  return <LegalDocumentLayout page={page} />;
}

export default PrivacyPolicyPage;
